module.exports = __webpack_public_path__ + "static/media/approved.6106a110.svg";